import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { AfterContentInit, Component, ContentChildren, EventEmitter, Input, OnChanges, Output, QueryList, SimpleChanges } from '@angular/core';
import { GridToggleStateComponent } from './grid-toggle-state/grid-toggle-state.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'tt-grid-toggle',
    templateUrl: './grid-toggle.component.html',
    styleUrls: ['./grid-toggle.component.css'],
})
export class GridToggleComponent implements OnChanges, AfterContentInit {
    @ContentChildren(GridToggleStateComponent)
    public toggleStates = new QueryList<GridToggleStateComponent>();

    /**
     * The text to display in the button.
     */
    @Input()
    public ttId: string = '';

    /**
     * Whether the button is disabled.
     */
    @Input()
    public get ttDisabled(): boolean | 'hidden' {
        return this._disabled;
    }
    public set ttDisabled(value: BooleanInput | '1' | 1 | 0 | '0' | 'hidden') {
        if (value == 'hidden') {
            this._disabled = 'hidden';
        } else {
            this._disabled = this.customCoerceBoolenProperty(value);
        }
    }
    private _disabled: boolean | 'hidden' = false;

    /**
     * The variant of the button, default is `'primary'`.
     */
    @Input()
    public ttKind?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'link' | 'ghost-danger' | 'icon';
    public buttonClasses: string = 'ag-button ag-floating-filter-button-button tt-grid__toolbar-button';

    @Input()
    public ttStateIndex = 0;

    @Output()
    public ttStateIndexChange = new EventEmitter<number>();

    private setButtonClasses() {
        if (!this.ttKind) return;

        let classes = 'tt-button';

        if (this.ttKind.includes('primary')) {
            classes += ' tt-button--primary';
        } else if (this.ttKind.includes('danger')) {
            classes += ' tt-button--danger';
        } else if (this.ttKind.includes('success')) {
            classes += ' tt-button--success';
        } else if (this.ttKind.includes('warning')) {
            classes += ' tt-button--warning';
        } else if (this.ttKind.includes('secondary')) {
            classes += ' tt-button--secondary';
        }

        classes += ' ' + this.ttKind;

        this.buttonClasses = classes;

        this.toggleStates.forEach((state) => (state.buttonClasses = this.buttonClasses));
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['ttDisabled']) {
            this.ttDisabled = changes['ttDisabled'].currentValue;
        }

        if (changes['ttKind']) {
            this.setButtonClasses();
        }

        // if (changes['ttStateIndex']) {
        //     if (this.ttStateIndex === undefined || this.ttStateIndex > this.toggleStates.length) {
        //         // if the index is out of range when configuring buttons the index is set back to 0;
        //         this.ttStateIndex = 0;
        //         this.ttStateIndexChange.emit(this.ttStateIndex);
        //     }
        // }
    }

    private updateStateIndex(index: number) {
        const newIndex = (index + 1) % this.toggleStates.length;

        this.ttStateIndex = newIndex;
        this.ttStateIndexChange.emit(this.ttStateIndex);
        this.toggleStates.forEach((state, i) => (state.elementRef.nativeElement.hidden = i !== this.ttStateIndex));
    }

    private clickSubscriptions: Subscription[] = [];

    ngAfterContentInit(): void {
        this.configureToggleStates(this.toggleStates);

        this.toggleStates.changes.subscribe({
            next: (toggleStates: QueryList<GridToggleStateComponent>) => {
                this.configureToggleStates(toggleStates);
            },
        });
    }

    private configureToggleStates(toggleStates: QueryList<GridToggleStateComponent>) {
        for (let subscription of this.clickSubscriptions) {
            subscription.unsubscribe();
        }

        this.clickSubscriptions = [];

        if (this.ttStateIndex === undefined || this.ttStateIndex > this.toggleStates.length) {
            // if the index is out of range when configuring buttons the index is set back to 0;
            this.ttStateIndex = 0;
            this.ttStateIndexChange.emit(this.ttStateIndex);
        }

        toggleStates.forEach((state, index) => {
            state.elementRef.nativeElement.hidden = index !== this.ttStateIndex;
            this.clickSubscriptions.push(state.ttClick.subscribe({ next: () => this.updateStateIndex(index) }));
            state.buttonClasses = this.buttonClasses;
        });
    }

    private customCoerceBoolenProperty(value: any): boolean {
        if (['1', '0', 1, 0, 'true', true, 'false', false].includes(value)) {
            return ['1', 1, true, 'true'].includes(value as any);
        }
        return coerceBooleanProperty(value);
    }
}
